module.exports = __webpack_public_path__ + "static/media/person-fill.a9ac516f.svg";